import { render, staticRenderFns } from "./ModalCompanyMobileRelease.vue?vue&type=template&id=36026054"
import script from "./ModalCompanyMobileRelease.vue?vue&type=script&lang=js"
export * from "./ModalCompanyMobileRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports